export default __webpack_public_path__ + "static/media/bg8.618be1b8.png";